import { createFileRoute } from "@tanstack/react-router";
import ShareAcceptPage from "@/site/pages/share-accept";

// Public Reminder Share landing (PRD 02 D13): anyone with the link previews the shared
// dates; accepting requires sign-in and dedup-imports them into "Shared with you".
export const Route = createFileRoute("/shares/$token")({
  component: ShareAcceptPage,
});
